import e from"react";const t=({children:t})=>t?e.createElement("div",{className:"text-color-subtle text-sm"},t):null;export{t as default};
